export const REQUIRED_OPTIONS = [
    'lowercase',
    'uppercase',
    'symbol',
    'number',
];
export const SPECIAL_SYMBOLS = '.!@#$%^&*()_+=<>-';
